<template>
    <div style="margin: 0 auto;">
        <video  
            ref="videoPlayer"
            data-dashjs-player="" 
            :src="info.url"
            controls="true"
            autoplay="false"
            class="video">
        </video>
    </div>
</template>

<script>
    import $ from 'jquery'
    import Url from '@/constant/Url';

    export default {
        name:'VideoPlayer',
        props:["info"],
        data() {
            return {
                url:'',
                courseVideo:{},
            }
        },
        mounted() {
            
            console.log("info", this.info)
            const videoPlayer = this.$refs.videoPlayer;
            const player = dashjs.MediaPlayer().create();

            player.initialize(videoPlayer, videoPlayer.src, true);

            /* 上面别管 */
        },
        methods: {
            
        }
    }
</script>

<style scoped>
.video {
    width: 96%;
    height: 48%; 
    border: 3px solid black; 
    margin-top: 20px;
    margin-left: calc(2%);
}
/* 样式 */
</style>
